import React from 'react';
import { Box, Paper, Avatar, Typography } from '@mui/material';

const MessageItem = ({ msg, colors, avatar }) => {
  return (
    <Box display="flex" justifyContent={msg.from === 'ai' ? 'flex-start' : 'flex-end'} mb={1}>
      {msg.from === 'ai' && <Avatar src={avatar} alt="Avatar" sx={{ width: 36, height: 36, marginRight: 2 }} />}
      <Paper
        elevation={3}
        sx={{
          padding: 1,
          maxWidth: '60%',
          backgroundColor: msg.from === 'ai' ? '#f1f1f1' : colors.secondary.backgroundColor,
          color: msg.from === 'ai' ? '#000' : colors.secondary.color,
        }}
      >
        <Typography variant="body2" dangerouslySetInnerHTML={{ __html: msg.body }} />
      </Paper>
    </Box>
  );
};

export default MessageItem;